import { FileExtensionToRenderer, FileExtensions } from '../constants';
import { FileRenderer } from '../enums';
import { FileInfo } from '../models';
import { getFileExtension } from './file-name-helper';

const threedViewerExtensions = new Set<string>([
  FileExtensions.stl,
  FileExtensions.ply,
  FileExtensions.obj,
  FileExtensions.spr,
  FileExtensions.drc,
]);

function getRendererForFile(file: FileInfo): FileRenderer | undefined {
  const extension = getFileExtension(file.name, true);

  if (threedViewerExtensions.has(extension)) {
    return FileRenderer.threedViewer;
  }

  return FileExtensionToRenderer[extension];
}

export function resolveReviewRenderer(files: FileInfo[]): FileRenderer {
  if (files.length === 0) {
    return FileRenderer.threedViewer;
  }

  const renderers = files.map(getRendererForFile);

  if (renderers.some(renderer => renderer == null)) {
    return FileRenderer.threedViewer;
  }

  if (renderers.some(renderer => renderer === FileRenderer.threedViewer)) {
    return FileRenderer.threedViewer;
  }

  const uniqueRenderers = [...new Set(renderers.filter((renderer): renderer is FileRenderer => renderer != null))];

  if (uniqueRenderers.length === 1) {
    return uniqueRenderers[0];
  }

  return FileRenderer.threedViewer;
}
